import React, { useEffect, useRef } from 'react';
import { useInView, animate } from 'framer-motion';
function Counter({
  from,
  to,
  prefix = '',
  suffix = ''
}: {
  from: number;
  to: number;
  prefix?: string;
  suffix?: string;
}) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView && nodeRef.current) {
      const controls = animate(from, to, {
        duration: 2,
        ease: 'easeOut',
        onUpdate(value) {
          if (nodeRef.current) {
            nodeRef.current.textContent = prefix + Math.round(value) + suffix;
          }
        }
      });
      return () => controls.stop();
    }
  }, [from, to, inView, prefix, suffix]);
  return <span ref={nodeRef} data-id="element-257">
      {prefix}
      {from}
      {suffix}
    </span>;
}
export function SystemStats() {
  const stats = [{
    from: 0,
    to: 50,
    prefix: '+',
    label: 'Herramientas'
  }, {
    from: 0,
    to: 80,
    suffix: '+',
    label: 'Guiones listos'
  }, {
    from: 0,
    to: 11,
    label: 'PDFs completos'
  }, {
    from: 0,
    to: 7,
    suffix: ' días',
    label: 'Para ver resultados'
  }];
  const tags = ['Guiones de consulta', 'Protocolo de malas noticias', 'Objeciones de precio', 'Consentimiento informado', 'Checklist de consulta', 'Propietario emocional', 'Cierre de consulta', 'Presupuestos', 'Dueño hiperinformado', 'Frases de reemplazo'];
  return <section className="bg-green py-10 sm:py-14 px-5 text-center" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        <h2 className="font-display text-xl sm:text-3xl lg:text-4xl text-white mb-8 sm:mb-10 leading-tight" data-id="element-260">
          El sistema N°1 en Argentina
          <br data-id="element-261" />8 Tomos + 3 Bonos · Todo resuelto
        </h2>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-12 mb-8 sm:mb-10" data-id="element-262">
          {stats.map((stat, i) => <div key={i} data-id="element-263">
              <span className="font-display text-3xl sm:text-5xl font-bold text-gold-light block" data-id="element-264">
                <Counter from={stat.from} to={stat.to} prefix={stat.prefix} suffix={stat.suffix} data-id="element-265" />
              </span>
              <span className="text-[10px] sm:text-xs text-white/80 uppercase tracking-wider" data-id="element-266">
                {stat.label}
              </span>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5 max-w-3xl mx-auto" data-id="element-267">
          {tags.map((tag, i) => <span key={i} className="bg-white/15 text-white/90 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-[11px] sm:text-sm font-medium" data-id="element-268">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}